import moment from 'moment';

export const isVirtualAccountExpired = (expireDate, now = moment()) => {
    const expiration = moment(expireDate);
    if (!expiration.isValid()) return false;
    return expiration.isBefore(now);
};
